import {
  IPaymentCalculateResponse,
  IPaymentFlatTax,
  IPaymentTaxInput,
} from 'models/invoices.models'

const flatTaxToInput = (t: IPaymentFlatTax): IPaymentTaxInput => ({
  tipo: t.tipo,
  impuesto: t.impuesto,
  tipoFactor: t.tipoFactor ?? 'Tasa',
  tasaOCuota: t.tipoFactor === 'Exento' || t.tasaOCuota === null ? undefined : t.tasaOCuota,
  baseOriginal: t.base ?? 0,
})

export const buildTaxesFromCalculateResponse = (
  preview: IPaymentCalculateResponse
): IPaymentTaxInput[] => {
  // Prioridad 1: arreglo plano taxesDR (MonedaDR) — nuevo contrato
  if (preview.taxesDR && preview.taxesDR.length > 0) {
    return preview.taxesDR.map(flatTaxToInput)
  }
  // Prioridad 2: desglose por concepto (cuando el request incluyó conceptos[])
  if (preview.conceptos && preview.conceptos.length > 0) {
    return preview.conceptos.flatMap(c => [
      ...c.traslados.map(t => ({
        tipo: 'Traslado' as const,
        impuesto: t.impuesto,
        tipoFactor: t.tipoFactor,
        tasaOCuota: t.tipoFactor === 'Exento' ? undefined : t.tasaOCuota,
        baseOriginal: t.base,
      })),
      ...c.retenciones.map(r => ({
        tipo: 'Retencion' as const,
        impuesto: r.impuesto,
        tipoFactor: r.tipoFactor,
        tasaOCuota: r.tipoFactor === 'Exento' ? undefined : r.tasaOCuota,
        baseOriginal: r.base,
      })),
    ])
  }
  // Prioridad 3: legacy trasladosDR / retencionesDR
  return [
    ...(preview.trasladosDR ?? []).map(t => ({
      tipo: 'Traslado' as const,
      impuesto: t.impuesto,
      tipoFactor: t.tipoFactor,
      tasaOCuota: t.tipoFactor === 'Exento' ? undefined : t.tasaOCuota,
      baseOriginal: t.base ?? 0,
    })),
    ...(preview.retencionesDR ?? []).map(r => ({
      tipo: 'Retencion' as const,
      impuesto: r.impuesto,
      tipoFactor: r.tipoFactor,
      tasaOCuota: r.tipoFactor === 'Exento' ? undefined : r.tasaOCuota,
      baseOriginal: r.base ?? 0,
    })),
  ]
}
